const BASE_URL = 'https://s3.us-west-1.amazonaws.com/vegasmattstats.info';

export const DATA_YEARS = [2025, 2026];

export const YTD_CSV_BY_YEAR = {
  2025: `${BASE_URL}/ytd.csv`,
  2026: `${BASE_URL}/2026_ytd.csv`,
};

export const DISCORD_CSV_BY_YEAR = {
  2025: `${BASE_URL}/vegas_matt_out.csv`,
  2026: `${BASE_URL}/2026_vegas_matt_out.csv`,
};

export const SIDEBETS_CSV_BY_YEAR = {
  2025: `${BASE_URL}/sidebets.csv`,
  2026: `${BASE_URL}/2026_sidebets.csv`,
};

export const SOCIAL_CSV_BY_YEAR = {
  2025: `${BASE_URL}/social.csv`,
  2026: `${BASE_URL}/2026_social.csv`,
};

export const getCsvUrls = (map, years = DATA_YEARS) =>
  years.map((year) => map[year]).filter(Boolean);

